import { Component } from '@angular/core';
import { RAGType } from 'app/interfaces/annotation-and-rags';

@Component({
  selector: 'app-issue-tracking-export',
  standalone: false,
  templateUrl: './issue-tracking-export.component.html',
  styleUrl: './issue-tracking-export.component.css'
})
export class IssueTrackingExportComponent {

}

export interface IIssueTrackingExportItem {
  columns: {
    assets: boolean,
    assignee: boolean,
    comments: boolean,
    completedAt: boolean,
    completedBy: boolean,
    createdAt: boolean,
    days: boolean,
    description: boolean,
    org: boolean,
    rag: RAGType,
    summary: boolean,
    substatus_id: boolean,
    lastComment: boolean,
    lastCommentDate: boolean
  },
  delivery: IIssueTrackingExportItemDelivery
}


export type IIssueTrackingExportItemDelivery = 'download' | 'email';
